<template>
  <div>
    <div><input v-model='days' @keyup.enter="enterClicked()"/></div>
    <div class="row">
      <div class="col-sm-6">
        <UsersStackedLine :data=usagers.data></UsersStackedLine>
      </div>
      <div class="col-sm-6">
        <ActivityByType :data=activite.data></ActivityByType>
      </div>
      <div class="col-sm-6">
        <ActiveLhins :data=lhinActivity.data></ActiveLhins>
      </div>
      <div class="col-sm-6">
        <ActiveHsps :data=hspActivity.data></ActiveHsps>
      </div>
    </div>
  </div>
</template>

<script>
import UsersStackedLine from '@/components/UsersStackedLine.vue'
import ActivityByType from '@/components/ActivityByType.vue'
import ActiveLhins from '@/components/ActiveLhins.vue'
import ActiveHsps from '@/components/ActiveHsps.vue'
import axios from 'axios';

export default {
  data: function() {return {
    days: 45,
    usagers: {data: []},
    activite: {data: []},
    lhinActivity: {data: []},
    hspActivity: {data: []},
    browser: {data: {browser: [], os: []}}
  }},

  name: 'Normstest',
  components: {
    UsersStackedLine,
    ActivityByType,
    ActiveLhins,
    ActiveHsps
  },
  methods: {
    enterClicked: function() {
      this.refresh()
    },
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/connexions.php',
          { params: {days: this.days} })
        .then(response => (this.usagers = response))

      axios
        .get(this.$root.$data.server_base + '/api/on/activity_index.php',
          { params: {days: this.days} })
        .then(response => (this.activite = response))

      axios
        .get(this.$root.$data.server_base + '/api/on/active_users_by_lhin.php',
          { params: {days: this.days} })
        .then(response => (this.lhinActivity = response))

      axios
        .get(this.$root.$data.server_base + '/api/on/active_hsps.php',
          { params: {days: this.days} })
        .then(response => (this.hspActivity = response))

    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style>
  div.graph {
    display: inline-block;
    width: 46%;
    background-color: #f5f5f5;
    border: 1px #c5c5c5 solid;
    border-radius: 5px;
    margin: 5px;
    padding: 15px;
  }
</style>
